import { takeLatest } from "redux-saga/effects";
import { getAllAudioLanguageAction } from "./slices";
import { getAllAudioLanguageWorker } from "./workers";

const audioLanguageWatcher = [
  takeLatest(getAllAudioLanguageAction, getAllAudioLanguageWorker),
];

export default audioLanguageWatcher;
